/** @format */

import React, { useCallback, useEffect } from 'react';

import usePortal from 'react-cool-portal';

import * as styles from '../modal.module.scss';

const useModal = (options = {}) => {
  const { Portal, ...rest } = usePortal({
    ...options,
    containerId: 'modal',
    defaultShow: false,
    internalShowHide: false,
  });

  const Modal = useCallback(
    ({ isShow, children, onClose, background = '40, 40, 40', opacity = 0.6, transition = 0.15 }) => {
      const onCloseHandler = () => {
        onClose();
      };

      const escHandler = e => {
        if (e.keyCode === 27) {
          onClose();
        }
      };
      const stopPropagation = e => e.stopPropagation();

      useEffect(() => {
        const getScrollbarWidth = () => {
          const div = document.createElement('div');
          div.style.width = '100px';
          div.style.height = '100px';
          div.style.overflow = 'scroll';
          div.style.position = 'absolute';
          div.style.top = '-9999px';

          document.body.appendChild(div);
          const scrollbarWidth = div.offsetWidth - div.clientWidth;
          document.body.removeChild(div);

          return scrollbarWidth;
        };

        const scrollbarWidth = getScrollbarWidth();
        // Function to apply styles to the html tag
        const applyStylesToHtml = () => {
          if (isShow) {
            document.body.style.setProperty('padding-right', `${scrollbarWidth}px`);
            document.body.style.setProperty('overflow', 'hidden');
          } else {
            document.body.style.removeProperty('padding-right');
            document.body.style.removeProperty('overflow');
          }
        };

        document.getElementById('modal').style.zIndex = '9999999999';
        document.getElementById('modal').style.position = 'fixed';

        // Apply styles on mount and whenever isModalOpen changes
        applyStylesToHtml();

        // Cleanup function
        return () => {
          // Reset styles when the component is unmounted
          applyStylesToHtml();
        };
      }, [isShow]);

      return (
        <Portal>
          <div
            className={`${styles.modal} ${isShow ? styles.visible : ''}`}
            onClick={onCloseHandler}
            tabIndex={-1}
            onKeyDown={escHandler}
            style={{
              backgroundColor: `rgba(${background}, ${opacity})`,
              transition: `opacity ${transition}s, visibility ${transition}s`,
            }}
            aria-hidden
          >
            <div onClick={stopPropagation} className={styles.container} aria-hidden>
              {children}
            </div>
          </div>
        </Portal>
      );
    },
    [],
  );

  return { Modal, ...rest };
};

export default useModal;
